/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { REVIEW_FORECAST_MAX_TIMEZONE_OFFSET_MINUTES } from '@repo/config';
import { z } from 'zod';

export const getProgressForecastV1RequestSchema = z.object({
  timezoneOffsetMinutes: z
    .number()
    .int()
    .min(-REVIEW_FORECAST_MAX_TIMEZONE_OFFSET_MINUTES)
    .max(REVIEW_FORECAST_MAX_TIMEZONE_OFFSET_MINUTES)
    .optional(),
});

export interface IGetProgressForecastV1Request {
  timezoneOffsetMinutes?: number;
}
